import React from "react";
import { Card } from "reactstrap";
import { Book, FileText, Briefcase, AlignJustify, Inbox } from "react-feather";

function IconArea(props) {
  const { select, csv } = props;
  if (csv === "facturacion") return <Inbox size="1.5vw" color={select === true ? "#000000de" : "#777d84"} />;
  if (csv === "sucursal") return <Briefcase size="1.5vw" color={select === true ? "#000000de" : "#777d84"} />;
  if (csv === "nominas") return <AlignJustify size="1.5vw" color={select === true ? "#000000de" : "#777d84"} />;
  if (csv === "cobranzas") return <FileText size="1.5vw" color={select === true ? "#000000de" : "#777d84"} />;
  return <Book size="1.5vw" color={select === true ? "#000000de" : "#777d84"} />;
}

export default function AreasCard(props) {
  const { className, select, onClick, text, csv } = props;
  const classArea = select ? "area-card-selected" : "area-card";
  const classFooter = select === true ? "area-footer-selected" : "area-footer";

  return (
    <Card type="div" className={`${classArea} ${className}`} onClick={onClick}>
      <div className={classFooter}>
        {text} <IconArea csv={csv} select={select} />
      </div>
    </Card>
  );
}
